import { removeDiacritics } from '@oskecare/fe-utilities/scripts/helpers';

/**
 * @param {string} name
 * @param {string} order
 * @param {?string} catalogType
 */
export class Category {
  constructor({ name, order, catalogType = null }) {
    this.name = name;
    this.order = order;
    this.catalogType = catalogType;
  }

  /**
   * @returns {string}
   */
  get slug() {
    return removeDiacritics(this.name)
      .toLowerCase()
      .replace(/[^a-z0-9 -]/g, '') // remove invalid chars
      .replace(/\s+/g, '-') // collapse whitespace and replace by `-`
      .replace(/-+/g, '-'); // collapse dashes
  }
}
